module.exports = __webpack_public_path__ + "img/7.bc64420c.svg";